import { ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import {
    Income,
    KPITarget,
    KPIServiceGroup,
    DefaultKPITarget,
    IncomeStats,
} from '../types'
import { CreateKPIFormData } from '../components/KPIManagement/CreateKPI'

interface IncomeQueryParams {
    q: string
    page: number
    page_size: number
    sort_by: string
    sort_order: string
    filters: string
}

export const getEmployeeIncomes = async (params: IncomeQueryParams) => {
    const { page, page_size, q, sort_by, sort_order, filters } = params
    const sortParams = sort_by
        ? `&sort_by=${sort_by}&sort_order=${sort_order || 'asc'}`
        : ''
    const response = await datacentral.get<ResponseArray<Income>>(
        `reports/employees/incomes?q=${q}&page=${page}&page_size=${page_size}${sortParams}&filters=${filters}`
    )
    if (!response || !response.data)
        return { results: [], pagination: undefined }
    return response.data
}

export const getEmployeeIncomesStats = async (params: {
    q: string
    filters: string
}) => {
    const response = await datacentral.get<ResponseObject<IncomeStats>>(
        `reports/employees/incomes/stats?q=${params.q}&filters=${params.filters}`
    )
    if (!response || !response.data) return { result: null }
    return response.data
}

export const getEmployeeKPITargets = async (employee_id: number) => {
    const response = await datacentral.get<ResponseArray<KPITarget>>(
        `employees/kpis/${employee_id}`
    )
    if (!response || !response.data) return { results: [] }
    return response.data
}

export const saveEmployeeKPITarget = async (data: CreateKPIFormData[]) => {
    const response = await datacentral.post(`employees/kpis`, {
        employees: data,
    })
    return response.data
}

export const updateEmployeeKPITarget = async (
    id: number,
    payload: Partial<KPITarget>
) => {
    const response = await datacentral.put<ResponseObject<KPITarget>>(
        `reports/employees/kpi-targets/${id}`,
        payload
    )
    return response.data
}

export const deleteEmployeeKPITarget = async (id: number) => {
    const response = await datacentral.delete(
        `reports/employees/kpi-targets/${id}`
    )
    return response.data
}

export const getKPIServiceGroups = async () => {
    const response = await datacentral.get<ResponseArray<KPIServiceGroup>>(
        `reports/kpi-service-groups`
    )
    if (!response || !response.data) return { results: [] }
    return response.data
}

export const getDefaultKPITargets = async () => {
    const response = await datacentral.get<ResponseArray<DefaultKPITarget>>(
        `employees/kpis/default`
    )
    if (!response || !response.data) return { results: [] }
    return response.data
}
